export const OpenPositionReducer = (state = {}, action) => {
    switch (action?.type) {
        case "FETCH_OPEN_POSITIONS":
            return {
                ...state,
                openPositions: action?.payload,
            };

        default:
            return state;
    }
};
